import React from 'react';
import { Translator, useTranslationSync } from '@piwikpro/ui-components';

export default ({ children }: { children: React.ReactNode }) => {
  useTranslationSync({
    enabled: process.env.NODE_ENV === 'development',
  });

  return (
    <Translator>
      {children}
    </Translator>
  );
};
